/**
 * Generated runtime TestId mirror for frontend/src/components/identity/AccessSnapshotView.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const AccessSnapshotViewTestIds = {
  colEntitlement: "col-entitlement",
  colOperation: "col-operation",
  colResource: "col-resource",
  colSource: "col-source",
  colValidUntil: "col-valid-until"
} as const;
